import PATHS from "./paths";

import { AvailableRoles } from "@/types";

const dashboardPathByRole: Record<AvailableRoles, string> = {
  [AvailableRoles.STUDENT]: PATHS.STUDENT.DASHBOARD,
  [AvailableRoles.TUTOR]: PATHS.TUTOR.DASHBOARD,
};

export default dashboardPathByRole;
